import makeTypeCreator from '@/models/makeTypeCreator'

const createType = makeTypeCreator('bonusCoupon')

export const FETCH_LIST = createType('FETCH_LIST')
export const LIST_FETCHED = createType('LIST_FETCHED')
export const SHOW_BONUS_COUPON_DIALOG = createType('SHOW_BONUS_COUPON_DIALOG')
export const DELETE_BONUS_COUPON = createType('DELETE_BONUS_COUPON')
export const TOGGLE_LOADING = createType('TOGGLE_LOADING')
export const UPDATED = createType('UPDATED')